import { Link } from "gatsby"
import React, { Component } from "react"

import { Group, Col, CtaButton } from "./common"

class TopContainer extends Component {
  static defaultProps = {
    titleLines: [],
    body: "",
    backgroundImage: null,
    ctaText: null,
    ctaLinkTo: null,
  }

  renderTitle = () => {
    return this.props.titleLines.map(line => {
      return (
        <>
          {line}
          <br />
        </>
      )
    })
  }

  renderCta() {
    if (!this.props.ctaText || !this.props.ctaLinkTo) {
      return null
    }

    return (
      <CtaButton linkTo={this.props.ctaLinkTo}>{this.props.ctaText}</CtaButton>
    )
  }

  render() {
    return (
      <div
        className="top-container"
        style={{ backgroundImage: `url(${this.props.backgroundImage})` }}
      >
        <div className="wrap">

          <div className="accent-divider" />
          <h2>{this.renderTitle()}</h2>
          <p>{this.props.body}</p>
          {this.renderCta()}

        </div>
      </div>
    )
  }
}

export default TopContainer
